import { useMessageStyle } from './useMessageStyle';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'store/useAppSelector';
import { messageStore } from 'modules/common/store/message';

export const MessageBox = () => {
  const classes = useMessageStyle();
  const { message, type, duration } = useAppSelector(state => state.message);
  const dispatch = useDispatch();
  const timer: any = useRef(null);

  useEffect(() => {
    if (message) {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        dispatch(messageStore.actions.setMessage({ message: '', type: '' }));
      }, duration);
    }
  }, [message, dispatch, duration]);

  return (
    <div className={classNames(classes.root, 'message-wrap', type)}>
      {message && <span>{message}</span>}
    </div>
  );
};
